export const environment = {
  production: true,
  "apiURL": "https://api-gateway.mycargoservices.net/api/v3/",
  "apiURLV1": "https://api-gateway.mycargoservices.net/v1/",
  "tarifURL": "https://api-gateway.mycargoservices.net/tarifierung/v1/",
  "storageURL": "https://api-gateway.mycargoservices.net/storage/v1/",
  "printURL": "http://localhost:8792/v1/",
  "readerURL": "https://api-gateway.mycargoservices.net/reader/v1/",
  "exportDEToken": "5de9e842-95e0-419a-a617-597d34464018", //asendiaImport
  "storageToken": "09fe28fe-1d79-45dc-b1cc-96efd97d7f55",  //storage@SysAdminGroup
  "aasMandantToken": "4afa6c94-07d7-41f3-bed3-cb42a7503ac9",
  "InfoEmail": "cs@mycargogate.com"
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/environments/environment.ts